// /help/assignee — статья «Мне поручили задачу — что делать» (030: FR-018; research Р10): открытая
// страница без сеанса, сосед /login; ссылку дают «Первое письмо» и полоса первого входа.
import { createFileRoute } from '@tanstack/react-router';
import { AssigneeArticle } from '../features/help/AssigneeArticle.tsx';

export const Route = createFileRoute('/help/assignee')({
  component: AssigneeArticle,
});
